import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const login = async (email: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'login',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            email
        }
    });
}